import { TEMPLATE_MENU_OPTIONS } from 'modules/templateIndex/constants';

export const EMBEDDED_MODAL_CONTENT = {
  createPlacementModalHeader: 'Ready to start displaying embedded messages?',
  localesHelpText:
    'Select the locale you would like this template to fallback to. Iterable automatically defaults to the default locale you’ve configured in project settings.',
  localesPlaceholder: 'No localization options specified for the current project',
  localesTitleLabel: 'Template default locale*',
  modalHeaderLabel: TEMPLATE_MENU_OPTIONS.embedded.modalLabel,
  okayLabel: 'OK',
} as const;
